import alt from 'framework/alt';

class ReduxStoreActions {
  constructor() {
    this.generateActions(
      'setReduxStore',
    );
  }
}

export default alt.createActions(ReduxStoreActions);
